export default "__VITE_ASSET__CHWS77aH__"